import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import * as api from '../../../api';
import styled from 'styled-components';
import Spinner from '../../../Plateforme/Atoms/Spinner';
import H2 from '../../../Plateforme/Atoms/H2';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import { getEventDesignerDisplayName, getEventDesignerProfileLink } from '../../../Components/AdminPanels/utils/eventDesignerHelpers';
import Popup from '../../Atoms/Popup';
import BlueButton from '../../Atoms/BlueButton';
import FabFrIndicator from '../../Atoms/FabFrIndicator';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { FD100MultiSelectOptions } from '../../Utils/Listings';
import { supabase } from '../../../lib/supabaseClient';

// Winning project IDs for FD100 2025
const WINNER_PROJECT_IDS = [
    '67a332e21b103d938bafb0dc', '67a0b8331b103d938bafa954', '67aa1011740d844a3d633e93',
    '6829daa5754f51df2ef9141c', '67e6c18043d5609350e381a8', '67b5e6146890f1a147192905',
    '67be4a58b1ba28c3144aeb73', '67bf2330b1ba28c3144af8d2', '67c090dcdb48cb16a13c5b43',
    '677268097ec5d90c89d6fe63', '67c6b416db48cb16a13c73c7', '67ab652c07736060460b3b75',
    '68348986754f51df2ef9b87c', '67d15108d95ccf24eaf191df', '67d7d38c43d5609350e242a1',
    '67d82d2243d5609350e24c5e', '662adc507159e5b1b1da7c75', '67d8718c43d5609350e25c38',
    '67d1977243d5609350e218f2', '682b5c5f754f51df2ef93bbc', '67da910a43d5609350e274d7',
    '67e1864b43d5609350e2baeb', '67daebf343d5609350e27a9e', '67dd585043d5609350e28e57',
    '67dfeb0e43d5609350e2a360', '67e1452a43d5609350e2b066', '678675e2de3ed4a7001ab532',
    '67e2d05943d5609350e2cf97', '67e3e1cb43d5609350e304e5', '67e3e81543d5609350e308de',
    '67e3f02643d5609350e30a0a', '67e42d7043d5609350e32539', '67e42e5543d5609350e32570',
    '67e45c9843d5609350e329c0', '67e529f743d5609350e33a8c', '67e53aab43d5609350e340c3',
    '67e56ab043d5609350e3490f', '67e5764d43d5609350e34cb5', '67e57f5143d5609350e3519a',
    '67e5864c43d5609350e353a3', '67e58da443d5609350e3561d', '67e58ebc43d5609350e35665',
    '67e5ab6b43d5609350e35905', '67e6828d43d5609350e36b6a', '67e6acaf43d5609350e37832',
    '67e51ddb43d5609350e33667', '67e6c0a843d5609350e380cf', '67e6d53a43d5609350e38725',
    '67e6dfff43d5609350e38900', '67e7003c43d5609350e38bfc', '6834625c754f51df2ef9a4b1',
    '67ea99b76b7945ed1a576bae', '67f90250a0262e085d37088f', '67e1741a43d5609350e2b608',
    '67fe7a6c9167c049fff4e37e', '67ab6ade07736060460b3c16', '6810a343264e7745556acae1',
    '6800f4c59167c049fff51f5d', '6800b8529167c049fff50e47', '6800e76e9167c049fff5197f',
    '6800ef849167c049fff51c6f', '6800fad59167c049fff52224', '680113739167c049fff52d73',
    '680106139167c049fff525af', '680125219167c049fff53405', '680957ab9167c049fff5a7c2',
    '681164d36c8fbfe5e3c91e9e', '68020ef79167c049fff54015', '68025d069167c049fff56132',
    '680b728c9167c049fff5c8f7', '680249249167c049fff55a19', '68024ed89167c049fff55b90',
    '68025b1a9167c049fff56037', '680270379167c049fff566f5', '680274c09167c049fff567c8',
    '680275419167c049fff567de', '68027b389167c049fff56954', '680291609167c049fff56cad',
    '6802a3fc9167c049fff56f5f', '6849787b17dde4ca4c4bf043', '6849435a17dde4ca4c4be251',
    '6807cb759167c049fff58dd4', '6808c3f59167c049fff599c7', '6808c3859167c049fff599b1',
    '680fa4b19167c049fff5deee', '6801e2f49167c049fff53ce1', '680a54a09167c049fff5bbc4',
    '680b94b29167c049fff5cd49', '6810df4a264e7745556ad75d', '680fa3f89167c049fff5deb1',
    '680fa844a71ddf126b77b977', '680fa9f09167c049fff5e027', '6810c9b9264e7745556acf4d',
    '681125b66c8fbfe5e3c91c62', '6818cac19e656d77bc6c72fa', '6818d27e9e656d77bc6c75a3',
    '6818dbdf9e656d77bc6c78a0', '682d97b2754f51df2ef96070', '67fccffaa0262e085d370ddc',
    '680271809167c049fff5674a'
];

const Container = styled.div`
    max-width: 1400px;
    margin: 0 auto;
    padding: 20px;
`;

const HeaderSection = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 20px 0 30px 0;
    padding: 20px;
    background: linear-gradient(135deg, #f8f9fa, #e9ecef);
    border-radius: 12px;
    border: 1px solid #dee2e6;
`;

const SortSelect = styled.select`
    padding: 10px 15px;
    border: 2px solid #e0e0e0;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 600;
    background: white;
    cursor: pointer;
    transition: all 0.3s ease;
    
    &:hover {
        border-color: #2196f3;
    }
    
    &:focus {
        outline: none;
        border-color: #2196f3;
        box-shadow: 0 0 0 3px rgba(33, 150, 243, 0.1);
    }
`;

const StatsInfo = styled.div`
    font-size: 16px;
    color: #555;
    font-weight: 600;
`;

const ExportButton = styled.button`
    padding: 10px 20px;
    background: linear-gradient(135deg, #4caf50, #45a049);
    color: white;
    border: none;
    border-radius: 8px;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    gap: 8px;
    text-transform: none;
    
    &:hover {
        background: linear-gradient(135deg, #45a049, #388e3c);
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(76, 175, 80, 0.3);
    }
    
    &:active {
        transform: translateY(0);
    }
`;

const BallotageButton = styled.button`
    padding: 10px 20px;
    background: linear-gradient(135deg, #ff9800, #f57c00);
    color: white;
    border: none;
    border-radius: 8px;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    gap: 8px;
    text-transform: none;
    
    &:hover {
        background: linear-gradient(135deg, #f57c00, #ef6c00);
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(255, 152, 0, 0.3);
    }
    
    &:active {
        transform: translateY(0);
    }
`;

const ProjectGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
    gap: 25px;
    margin-top: 30px;
`;

const ProjectCard = styled.div`
    border: 1px solid #e0e0e0;
    border-radius: 12px;
    padding: 24px;
    background: white;
    transition: all 0.3s ease;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    position: relative;
    overflow: hidden;
    
    &:hover {
        box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
        transform: translateY(-2px);
        border-color: #2196f3;
    }
`;

const ProjectImage = styled.div`
    width: 100%;
    height: 220px;
    background-size: cover;
    background-position: center;
    background-color: #f8f9fa;
    border-radius: 8px;
    margin-bottom: 18px;
    border: 1px solid #eee;
`;

const ProjectName = styled.h3`
    margin: 0 0 12px 0;
    font-size: 20px;
    font-weight: 700;
    color: #1a1a1a;
    line-height: 1.3;
    display: flex;
    align-items: center;
    gap: 8px;
`;

const DesignerName = styled.p`
    margin: 0 0 16px 0;
    color: #666;
    font-size: 15px;
    font-weight: 500;
`;

const ViewButton = styled(Link)`
    display: inline-block;
    padding: 12px 20px;
    background: linear-gradient(135deg, #2196f3, #1976d2);
    color: white;
    text-decoration: none;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 600;
    text-align: center;
    transition: all 0.3s ease;
    box-shadow: 0 2px 8px rgba(33, 150, 243, 0.3);
    
    &:hover {
        background: linear-gradient(135deg, #1976d2, #1565c0);
        color: white;
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(33, 150, 243, 0.4);
    }
    
    &:visited {
        color: white;
    }
`;

const CategoryBadge = styled.span`
    display: inline-block;
    padding: 6px 12px;
    background: linear-gradient(135deg, #e3f2fd, #bbdefb);
    border: 1px solid #2196f3;
    color: #1976d2;
    border-radius: 20px;
    font-size: 12px;
    font-weight: 600;
    margin-bottom: 12px;
`;

const StatusBadge = styled.span`
    display: inline-block;
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 12px;
    margin-left: 10px;
    background: ${props => {
        if (props.status === 'validé') return '#4caf50';
        if (props.status === 'refusé') return '#f44336';
        return '#ff9800';
    }};
    color: white;
`;

const RatingsInfo = styled.div`
    display: flex;
    justify-content: space-between;
    margin: 16px 0;
    padding: 16px;
    background: linear-gradient(135deg, #f8f9fa, #e9ecef);
    border-radius: 8px;
    border: 1px solid #dee2e6;
    font-size: 12px;
`;

const RatingItem = styled.div`
    text-align: center;
    cursor: ${props => props.clickable ? 'pointer' : 'default'};
    transition: all 0.2s ease;
    
    &:hover {
        ${props => props.clickable ? 'transform: scale(1.05);' : ''}
    }
    
    .label {
        font-weight: 700;
        color: #555;
        font-size: 11px;
        text-transform: uppercase;
        letter-spacing: 0.5px;
        margin-bottom: 4px;
    }
    
    .value {
        font-size: 20px;
        font-weight: 800;
        color: #2196f3;
        text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
    }
`;

const ModalHeader = styled.div`
    text-align: center;
    padding: 20px 0 30px 0;
    border-bottom: 2px solid #f0f0f0;
    margin-bottom: 25px;
    
    h2 {
        color: #1a1a1a;
        margin-bottom: 8px;
        font-size: 24px;
        font-weight: 700;
    }
    
    .designer-name {
        color: #666;
        font-size: 16px;
        font-weight: 500;
    }
    
    .stats {
        display: flex;
        justify-content: center;
        gap: 30px;
        margin-top: 20px;
        
        .stat {
            text-align: center;
            
            .value {
                font-size: 24px;
                font-weight: 800;
                color: #2196f3;
                display: block;
            }
            
            .label {
                font-size: 12px;
                color: #888;
                text-transform: uppercase;
                letter-spacing: 0.5px;
                margin-top: 4px;
            }
        }
    }
`;

const CommentsContainer = styled.div`
    max-height: 400px;
    overflow-y: auto;
    padding-right: 10px;
    
    &::-webkit-scrollbar {
        width: 6px;
    }
    
    &::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 3px;
    }
    
    &::-webkit-scrollbar-thumb {
        background: #c1c1c1;
        border-radius: 3px;
        
        &:hover {
            background: #a8a8a8;
        }
    }
`;

const CommentCard = styled.div`
    background: white;
    border: 1px solid #e8e8e8;
    border-radius: 12px;
    padding: 20px;
    margin-bottom: 15px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
    transition: all 0.3s ease;
    
    &:hover {
        border-color: #2196f3;
        box-shadow: 0 4px 16px rgba(33, 150, 243, 0.1);
    }
    
    &:last-child {
        margin-bottom: 0;
    }
`;

const JuryInfo = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
    padding-bottom: 12px;
    border-bottom: 1px solid #f0f0f0;
    
    .jury-details {
        .name {
            font-weight: 700;
            font-size: 16px;
            color: #1a1a1a;
            margin-bottom: 2px;
        }
        
        .email {
            font-size: 13px;
            color: #888;
        }
    }
    
    .rating-info {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        gap: 4px;
        
        .score {
            font-size: 18px;
            font-weight: 800;
            color: #2196f3;
        }
        
        .heart {
            background: linear-gradient(135deg, #e91e63, #ad1457);
            color: white;
            padding: 4px 8px;
            border-radius: 12px;
            font-size: 11px;
            font-weight: 600;
            display: flex;
            align-items: center;
            gap: 4px;
        }
    }
`;

const CommentText = styled.div`
    font-size: 14px;
    line-height: 1.6;
    color: #333;
    background: #f8f9fa;
    padding: 15px;
    border-radius: 8px;
    border-left: 4px solid #2196f3;
    white-space: pre-wrap;
    
    &.no-comment {
        color: #999;
        font-style: italic;
        border-left-color: #ddd;
        background: #f5f5f5;
    }
`;

const ModalFooter = styled.div`
    text-align: center;
    padding-top: 25px;
    border-top: 2px solid #f0f0f0;
    margin-top: 25px;
`;

const ButtonContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-top: 20px;
`;

const BackButton = styled(Link)`
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 12px 20px;
    background: linear-gradient(135deg, #2196f3, #1976d2);
    color: white !important;
    text-decoration: none;
    border-radius: 8px;
    font-weight: 600;
    transition: all 0.3s ease;
    margin-bottom: 20px;
    box-shadow: 0 2px 8px rgba(33, 150, 243, 0.3);
    
    &:hover {
        background: linear-gradient(135deg, #1976d2, #1565c0);
        color: white !important;
        transform: translateX(-2px);
        box-shadow: 0 4px 12px rgba(33, 150, 243, 0.4);
    }
    
    &:visited {
        color: white !important;
    }
`;

const RankingBadge = styled.div`
    position: absolute;
    top: -8px;
    right: -8px;
    background: ${props => {
        if (props.rank === 1) return 'linear-gradient(135deg, #ffd700, #ffb300)';
        if (props.rank === 2) return 'linear-gradient(135deg, #c0c0c0, #999999)';
        if (props.rank === 3) return 'linear-gradient(135deg, #cd7f32, #b87333)';
        return 'linear-gradient(135deg, #ff6b35, #f7931e)';
    }};
    color: white;
    border-radius: 50%;
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 800;
    font-size: 14px;
    box-shadow: 0 2px 8px ${props => {
        if (props.rank === 1) return 'rgba(255, 215, 0, 0.5)';
        if (props.rank === 2) return 'rgba(192, 192, 192, 0.5)';
        if (props.rank === 3) return 'rgba(205, 127, 50, 0.5)';
        return 'rgba(255, 107, 53, 0.4)';
    }};
    border: 2px solid ${props => {
        if (props.rank === 1) return '#ffb300';
        if (props.rank === 2) return '#808080';
        if (props.rank === 3) return '#a0522d';
        return '#e85d2a';
    }};
    z-index: 10;
`;

const ProjectCardWrapper = styled.div`
    position: relative;
`;

const SelectionPanel = styled.div`
    position: fixed;
    right: 20px;
    top: 100px;
    width: 350px;
    max-height: 80vh;
    background: white;
    border: 2px solid #2196f3;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
    overflow: hidden;
    display: flex;
    flex-direction: column;
    z-index: 100;
`;

const SelectionHeader = styled.div`
    padding: 20px;
    background: linear-gradient(135deg, #2196f3, #1976d2);
    color: white;
    
    h3 {
        margin: 0 0 10px 0;
        font-size: 18px;
    }
    
    p {
        margin: 0;
        font-size: 14px;
        opacity: 0.9;
    }
`;

const SelectionList = styled.div`
    flex: 1;
    overflow-y: auto;
    padding: 15px;
    background: #f8f9fa;
`;

const SelectedProject = styled.div`
    background: white;
    border: 1px solid #ddd;
    border-radius: 8px;
    padding: 12px;
    margin-bottom: 10px;
    cursor: move;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    gap: 10px;
    
    &:hover {
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }
    
    ${props => props.isDragging && `
        box-shadow: 0 4px 16px rgba(33, 150, 243, 0.3);
        transform: scale(1.02);
    `}
    
    .rank {
        font-weight: 700;
        color: #2196f3;
        font-size: 16px;
        width: 30px;
    }
    
    .info {
        flex: 1;
        
        .name {
            font-weight: 600;
            font-size: 14px;
            margin-bottom: 3px;
        }
        
        .designer {
            font-size: 12px;
            color: #666;
        }
    }
    
    .remove {
        cursor: pointer;
        color: #dc3545;
        font-size: 18px;
        
        &:hover {
            color: #c82333;
        }
    }
`;

const SelectionFooter = styled.div`
    padding: 20px;
    border-top: 1px solid #e0e0e0;
    background: white;
`;

const ValidateButton = styled.button`
    width: 100%;
    padding: 12px;
    background: linear-gradient(135deg, #4caf50, #45a049);
    color: white;
    border: none;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    
    &:hover:not(:disabled) {
        background: linear-gradient(135deg, #45a049, #388e3c);
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(76, 175, 80, 0.3);
    }
    
    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
`;

const SelectButton = styled.button`
    position: absolute;
    top: 10px;
    left: 10px;
    padding: 8px 16px;
    background: ${props => props.selected ? '#dc3545' : '#4caf50'};
    color: white;
    border: none;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    z-index: 11;
    transition: all 0.3s ease;
    
    &:hover {
        background: ${props => props.selected ? '#c82333' : '#45a049'};
        transform: scale(1.05);
    }
`;

const FD100ProjectsInCompetition = () => {
    const { i18n } = useTranslation();
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [event, setEvent] = useState(null);
    const [allProjects, setAllProjects] = useState([]);
    const [ratings, setRatings] = useState([]);
    const [loading, setLoading] = useState(true);
    const [sortBy, setSortBy] = useState('votes');
    const [selectedProject, setSelectedProject] = useState(null);
    const [showComments, setShowComments] = useState(false);
    const ballotageMode = searchParams.get("ballotage") === "true";
    
    // Create categories mapping like in FDProjetsList.js
    const tyoplogieEspaceFD100Fr = FD100MultiSelectOptions.tyoplogieEspaceFD100("fr");
    const typologieObjetFD100Fr = FD100MultiSelectOptions.typologieObjetFD100("fr");
    const tyoplogieEspaceFD100En = FD100MultiSelectOptions.tyoplogieEspaceFD100("en");
    const typologieObjetFD100En = FD100MultiSelectOptions.typologieObjetFD100("en");
    
    // Merge categories and remove duplicates for French
    const FDCategoriesFr = [
        ...tyoplogieEspaceFD100Fr,
        ...typologieObjetFD100Fr,
    ].filter((cat, index, self) => self.findIndex((t) => t.value === cat.value) === index);
    
    // Merge categories and remove duplicates for English
    const FDCategoriesEn = [
        ...tyoplogieEspaceFD100En,
        ...typologieObjetFD100En,
    ].filter((cat, index, self) => self.findIndex((t) => t.value === cat.value) === index);
    
    // Helper function to get translated category label from code (French)
    const getCategoryLabel = (categoryCode) => {
        if (!categoryCode) return 'Sans catégorie';
        const category = FDCategoriesFr.find(cat => cat.value === categoryCode);
        return category ? category.label : categoryCode;
    };

    // Helper function to get English category label from code
    const getCategoryLabelEn = (categoryCode) => {
        if (!categoryCode) return 'Uncategorized';
        const category = FDCategoriesEn.find(cat => cat.value === categoryCode);
        return category ? category.label : categoryCode;
    };

    // Helper function to get typologie label based on project type
    const getProjectTypologieLabel = (project) => {
        const typologie = project.projet.typologie;
        const type = project.projet.type;

        if (!typologie) return i18n.language === 'fr' ? 'Sans catégorie' : 'Uncategorized';

        // Get the appropriate options based on type and language
        let options;
        if (type === 'objet') {
            options = i18n.language === 'fr' ? typologieObjetFD100Fr : typologieObjetFD100En;
        } else if (type === 'espace') {
            options = i18n.language === 'fr' ? tyoplogieEspaceFD100Fr : tyoplogieEspaceFD100En;
        } else {
            // Fallback to all categories
            options = i18n.language === 'fr' ? FDCategoriesFr : FDCategoriesEn;
        }

        const option = options.find(opt => opt.value === typologie);
        return option ? option.label : typologie;
    };
    
    // Selection state for ballotage projects
    const [selectedBallotageProjects, setSelectedBallotageProjects] = useState([]);
    const [showSelectionPanel, setShowSelectionPanel] = useState(false);
    const [generatingPDF, setGeneratingPDF] = useState(false);
    const [exportingExcel, setExportingExcel] = useState(false);

    useEffect(() => {
        const eventIdFromParam = searchParams.get("eid");
        if (eventIdFromParam) {
            api.getEventById({ id: eventIdFromParam }).then((response) => {
                setEvent(response.data);
            }).catch((error) => {
                console.log(error);
            });
        }
    }, [searchParams]);

    useEffect(() => {
        if (!event) return;
        
        setLoading(true);
        api.getParticipatingUsersWithData({ eventId: event._id }).then((response) => {
            let _allProjects = [];
            response.data.forEach(user => {
                if (user.participation.data.projets) {
                    user.participation.data.projets.forEach(project_id => {
                        const project = user.company.projects.find((projet) => projet._id === project_id);
                        if (project && project.status === "validé") {
                            _allProjects.push({
                                projet: { ...project, participationId: user.participation._id },
                                user: user
                            });
                        }
                    });
                }
            });
            setAllProjects(_allProjects);
            setLoading(false);
        }).catch((error) => {
            console.log(error);
            setLoading(false);
        });
    }, [event]);

    useEffect(() => {
        if (!event) return;
        api.getAllJuriesForEvent({ eventId: event._id }).then((response) => {
            let _allJuries = response.data.sort((a,b) => a.last_name.localeCompare(b.last_name));
            let _ratings = [];
            _allJuries.forEach(jury => {
                if (jury.juryNotes) {
                    jury.juryNotes.forEach(rating => {
                        rating.jury = jury;
                        let _projetIndex = _ratings.findIndex(r => r.id === rating.participationId + rating.projetId);
                        if (_projetIndex === -1) {
                            _ratings.push({id : rating.participationId + rating.projetId, ratings : [{rating}]});
                        } else {
                            _ratings[_projetIndex].ratings.push({rating});
                        }
                    });
                }
            });
            setRatings(_ratings);
        }).catch((error) => {
            console.log(error);
        });
    }, [event]);

    const getProjectImage = (project) => {
        if (project.medias && project.medias.length > 0) {
            const firstMedia = project.medias[0];
            if (firstMedia.type.includes('image')) {
                return process.env.REACT_APP_MEDIA_BASE_URL + "userfiles/" + firstMedia.path;
            } else if (firstMedia.type.includes('pdf')) {
                const filename = firstMedia.path.split('/').pop();
                const pdfPreviewPath = firstMedia.path.replace(filename, "firstpage_" + filename).replace('.pdf', '.png');
                return process.env.REACT_APP_MEDIA_BASE_URL + "userfiles/" + pdfPreviewPath;
            }
        }
        return null;
    };

    const getProjectRatings = (project) => {
        return ratings.find(rating => rating.id === project.projet.participationId + project.projet._id)?.ratings || [];
    };

    const cumulNoteOfProj = (project) => {
        const _ratings = getProjectRatings(project);
        return _ratings.reduce((totalStars, rating) => totalStars + (rating.rating.stars || 0), 0);
    };

    const cumulMentionsForProj = (project) => {
        const _ratings = getProjectRatings(project);
        return _ratings.reduce((total, rating) => total + (rating.rating.Coup_de_coeur === "checked" ? 1 : 0), 0);
    };

    const cumulDepartagePoints = (project) => {
        const _ratings = getProjectRatings(project);
        return _ratings.reduce((total, rating) => total + (rating.rating.jury2025_departage_point ? 1 : 0), 0);
    };

    const commentairesForProj = (project) => {
        const _ratings = getProjectRatings(project);
        return _ratings.reduce((total, rating) => total + (rating.rating.commentaire ? 1 : 0), 0);
    };

    const hasFabricationFrancaise = (project) => {
        return project.projet.fabrication_fr === "oui";
    };

    // Filter projects based on ballotage mode
    const filteredProjects = ballotageMode 
        ? allProjects.filter(project => 
            cumulDepartagePoints(project) === 1
        )
        : allProjects;

    const sortedProjects = [...filteredProjects].sort((a, b) => {
        switch (sortBy) {
            case 'votes':
                const voteDiff = cumulNoteOfProj(b) - cumulNoteOfProj(a);
                // If votes are equal, sort by mentions as secondary criterion
                if (voteDiff === 0) {
                    const mentionDiff = cumulMentionsForProj(b) - cumulMentionsForProj(a);
                    // If mentions are also equal, sort by departage points
                    if (mentionDiff === 0) {
                        const departageDiff = cumulDepartagePoints(b) - cumulDepartagePoints(a);
                        // If departage points are also equal, sort by fabrication française
                        if (departageDiff === 0) {
                            return (hasFabricationFrancaise(b) ? 1 : 0) - (hasFabricationFrancaise(a) ? 1 : 0);
                        }
                        return departageDiff;
                    }
                    return mentionDiff;
                }
                return voteDiff;
            case 'mentions':
                const mentionDiff = cumulMentionsForProj(b) - cumulMentionsForProj(a);
                // If mentions are equal, sort by votes as secondary criterion
                if (mentionDiff === 0) {
                    return cumulNoteOfProj(b) - cumulNoteOfProj(a);
                }
                return mentionDiff;
            case 'commentaires':
                const commentDiff = commentairesForProj(b) - commentairesForProj(a);
                // If comments are equal, sort by votes as secondary criterion
                if (commentDiff === 0) {
                    return cumulNoteOfProj(b) - cumulNoteOfProj(a);
                }
                return commentDiff;
            case 'name':
                const nameA = i18n.language !== 'fr' && a.projet.name_en ? a.projet.name_en : a.projet.name;
                const nameB = i18n.language !== 'fr' && b.projet.name_en ? b.projet.name_en : b.projet.name;
                return nameA.localeCompare(nameB);
            default:
                return 0;
        }
    });

    const openComments = (project) => {
        setSelectedProject(project);
        setShowComments(true);
    };

    const toggleBallotageMode = () => {
        const newParams = new URLSearchParams(searchParams);
        
        if (ballotageMode) {
            // Remove ballotage parameter
            newParams.delete('ballotage');
            setSelectedBallotageProjects([]);
            setShowSelectionPanel(false);
        } else {
            // Add ballotage parameter
            newParams.set('ballotage', 'true');
        }
        
        navigate(`?${newParams.toString()}`, { replace: true });
    };

    const toggleProjectSelection = (project) => {
        setSelectedBallotageProjects(prev => {
            const isSelected = prev.some(p => p.projet._id === project.projet._id);
            
            if (isSelected) {
                return prev.filter(p => p.projet._id !== project.projet._id);
            } else {
                // Count how many projects have exactly 1 departage point
                const ballotageCount = allProjects.filter(p => cumulDepartagePoints(p) === 1).length;
                if (prev.length < ballotageCount) {
                    setShowSelectionPanel(true);
                    return [...prev, project];
                } else {
                    alert(`Vous ne pouvez sélectionner que ${ballotageCount} projets maximum.`);
                    return prev;
                }
            }
        });
    };

    const removeFromSelection = (projectId) => {
        setSelectedBallotageProjects(prev => 
            prev.filter(p => p.projet._id !== projectId)
        );
    };

    const onDragEnd = (result) => {
        if (!result.destination) return;

        const items = Array.from(selectedBallotageProjects);
        const [reorderedItem] = items.splice(result.source.index, 1);
        items.splice(result.destination.index, 0, reorderedItem);

        setSelectedBallotageProjects(items);
    };

    const validateSelection = async () => {
        // Compute winner count with full rules
        const winnerCount = allProjects.filter(p => {
            const departage = cumulDepartagePoints(p);
            const votes = cumulNoteOfProj(p);
            const coups = cumulMentionsForProj(p);
            if (departage > 1) return true;
            if (departage === 0 && (votes >= 14 || (votes === 13 && coups >= 1))) return true;
            return false;
        }).length;
        const needed = 100 - winnerCount;
        if (selectedBallotageProjects.length !== needed) {
            alert(`Veuillez sélectionner exactement ${needed} projet(s) en ballotage.`);
            return;
        }

        // Get top projects (winners)
        const topProjects = allProjects.filter(p => {
            const departage = cumulDepartagePoints(p);
            const votes = cumulNoteOfProj(p);
            const coups = cumulMentionsForProj(p);
            if (departage > 1) return true;
            if (departage === 0 && (votes >= 14 || (votes === 13 && coups >= 1))) return true;
            return false;
        });

        // Save as top91 and ballotage9 for compatibility with FD100FinalSelection.js
        const finalSelection = {
            top91: topProjects,
            ballotage9: selectedBallotageProjects,
            eventId: event._id,
            eventTitle: event.title_fr,
            date: new Date().toISOString()
        };

        // Store in localStorage as backup
        localStorage.setItem('fd100_2025_selection', JSON.stringify(finalSelection));

        // Save to Supabase for persistence
        try {
            const { error } = await supabase
                .from('fd100_final_selection')
                .upsert({
                    event_id: event._id,
                    event_title: event.title_fr,
                    top91: topProjects,
                    ballotage9: selectedBallotageProjects,
                    updated_at: new Date().toISOString()
                }, { onConflict: 'event_id' });

            if (error) {
                console.error('Error saving to Supabase:', error);
                alert('Erreur lors de la sauvegarde dans Supabase. La sélection a été sauvegardée localement.');
            }
        } catch (err) {
            console.error('Supabase save error:', err);
        }

        // Navigate to final selection page
        navigate(`/admin/events/fd100finalselection?eid=${event._id}`);
    };

    const exportToExcel = async (winnersOnly = false, contactInfoOnly = false) => {
        // Refresh data before export
        setExportingExcel(true);
        try {
            const response = await api.getParticipatingUsersWithData({ eventId: event._id });
            let _allProjects = [];
            response.data.forEach(user => {
                if (user.participation.data.projets) {
                    user.participation.data.projets.forEach(project_id => {
                        const project = user.company.projects.find((projet) => projet._id === project_id);
                        if (project && project.status === "validé") {
                            _allProjects.push({
                                projet: { ...project, participationId: user.participation._id },
                                user: user
                            });
                        }
                    });
                }
            });

            // Apply ballotage filter if active
            const freshFilteredProjects = ballotageMode
                ? _allProjects.filter(project => cumulDepartagePoints(project) === 1)
                : _allProjects;

            // Sort projects by votes for export, with mentions, departage points and fabrication française as tiebreakers
            let projectsForExport = [...freshFilteredProjects].sort((a, b) => {
            const voteDiff = cumulNoteOfProj(b) - cumulNoteOfProj(a);
            // If votes are equal, sort by mentions
            if (voteDiff === 0) {
                const mentionDiff = cumulMentionsForProj(b) - cumulMentionsForProj(a);
                // If mentions are also equal, sort by departage points
                if (mentionDiff === 0) {
                    const departageDiff = cumulDepartagePoints(b) - cumulDepartagePoints(a);
                    // If departage points are also equal, sort by fabrication française
                    if (departageDiff === 0) {
                        return (hasFabricationFrancaise(b) ? 1 : 0) - (hasFabricationFrancaise(a) ? 1 : 0);
                    }
                    return departageDiff;
                }
                return mentionDiff;
            }
            return voteDiff;
        });

        // Filter to only winning projects if requested
        if (winnersOnly) {
            projectsForExport = projectsForExport.filter(project =>
                WINNER_PROJECT_IDS.includes(project.projet._id)
            );
            console.log(`Filtered to ${projectsForExport.length} winning projects out of ${freshFilteredProjects.length} total`);
        }


        // Prepare data for backend export
        const projectsData = projectsForExport.map((project, index) => {
            const projectRatings = getProjectRatings(project);
            const comments = projectRatings
                .filter(r => r.rating.commentaire)
                .map(r => `${r.rating.jury.first_name} ${r.rating.jury.last_name}: ${r.rating.commentaire}`)
                .join(' | ');

            // Get additional project data
            const galerie = project.projet.editeur || '';
            const distributeur = project.projet.distributeur || '';
            const adresse = project.projet.adresse || '';

            // Get type de projet display value
            const typeDeProjet = project.projet.type === 'objet' ? 'Objet' :
                                 project.projet.type === 'espace' ? 'Espace' :
                                 project.projet.type || '';

            // Get first image path from medias for preview
            let imagePath = '';
            if (project.projet.medias && project.projet.medias.length > 0) {
                console.log(`Project ${project.projet.name} has ${project.projet.medias.length} medias`);
                const firstImage = project.projet.medias.find(media =>
                    media.type && media.type.includes('image')
                );
                if (firstImage && firstImage.path) {
                    imagePath = firstImage.path;
                    console.log(`  Found image: ${imagePath}`);
                } else if (project.projet.medias[0] && project.projet.medias[0].type && project.projet.medias[0].type.includes('pdf')) {
                    // If first media is PDF, use its preview image path
                    const pdfMedia = project.projet.medias[0];
                    const filename = pdfMedia.path.split('/').pop();
                    const pdfPreviewPath = pdfMedia.path.replace(filename, 'firstpage_' + filename).replace('.pdf', '.png');
                    imagePath = pdfPreviewPath;
                    console.log(`  Using PDF preview: ${imagePath}`);
                } else {
                    console.log(`  No suitable image found`);
                }
            } else {
                console.log(`Project ${project.projet.name} has no medias`);
            }

            const baseData = {
                position: index + 1,
                imagePath: imagePath,
                nomProjet: project.projet.name,
                nomProjetEn: project.projet.name_en || '',
                designerEntreprise: getEventDesignerDisplayName(project.projet, project.user),
                ecole: project.user.hsProfile?.school || '',
                typeProjet: typeDeProjet,
                typologie: getProjectTypologieLabel(project),
                cumulVotes: cumulNoteOfProj(project),
                fabricationFrancaise: hasFabricationFrancaise(project) ? 'Oui' : 'Non',
                coupsDeCoeur: cumulMentionsForProj(project),
                pointsDepartage: cumulDepartagePoints(project),
                nombreCommentaires: commentairesForProj(project),
                commentairesDetailles: comments || 'Aucun commentaire',
                galerie: galerie,
                distributeur: distributeur,
                adresse: adresse,
                communiquerFabricants: project.projet.communiquer_fabricants || ''
            };

            // Add either fabricant info or contact info based on export type
            if (contactInfoOnly) {
                return {
                    ...baseData,
                    year: project.projet.year || '',
                    contactNom: project.user.participation?.data?.contact_nom || '',
                    contactPrenom: project.user.participation?.data?.contact_prenom || '',
                    contactEmail: project.user.participation?.data?.contact_mail || '',
                    contactTelephone: project.user.participation?.data?.contact_telephone || ''
                };
            } else {
                return {
                    ...baseData,
                    fabricants: project.projet.fabricants || '[]' // Keep as JSON string for backend to parse
                };
            }
        });

        // Log summary
        const projectsWithImages = projectsData.filter(p => p.imagePath).length;
        console.log(`Excel export summary:`);
        console.log(`  Total projects: ${projectsData.length}`);
        console.log(`  Projects with images: ${projectsWithImages}`);
        console.log(`  Projects without images: ${projectsData.length - projectsWithImages}`);

        // Call backend to generate Excel with embedded images
        const excelResponse = await api.exportFD100ProjectsExcel({
            eventId: event._id,
            projects: projectsData,
            language: i18n.language,
            contactInfoOnly: contactInfoOnly
        });

        // Create a blob from the response
        const blob = new Blob([excelResponse.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });

        // Create download link
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;

        // Generate filename with current date
        const date = new Date().toISOString().split('T')[0];
        let filename;
        if (contactInfoOnly) {
            filename = `FD100_Projets_Laureats_${date}.xlsx`;
        } else if (winnersOnly) {
            filename = `FD100_Projets_Laureats_Fabricants_${date}.xlsx`;
        } else {
            filename = `FD100_Projets_Competition_Fabricants_${date}.xlsx`;
        }
        link.download = filename;

        // Trigger download
        document.body.appendChild(link);
        link.click();

        // Cleanup
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        setExportingExcel(false);
        } catch (error) {
            console.error('Error exporting to Excel:', error);
            alert('Une erreur est survenue lors de l\'export. Veuillez réessayer.');
            setExportingExcel(false);
        }
    };

    const exportToPDF = async () => {
        try {
            setGeneratingPDF(true);
            
            // Get ballotage projects (exactly 1 departage point)
            const ballotageProjects = allProjects.filter(project => 
                cumulDepartagePoints(project) === 1
            );

            // Sort ballotage projects by name
            const sortedBallotageProjects = [...ballotageProjects].sort((a, b) => 
                {
                    const nameA = i18n.language !== 'fr' && a.projet.name_en ? a.projet.name_en : a.projet.name;
                    const nameB = i18n.language !== 'fr' && b.projet.name_en ? b.projet.name_en : b.projet.name;
                    return nameA.localeCompare(nameB);
                }
            );

            const projectsForPDF = sortedBallotageProjects.map(project => {
                // Build the fiche candidat URL based on candidate_as_person_fd100_25
                const baseUrl = window.location.origin;
                let ficheCandidat;
                if (project.projet.candidate_as_person_fd100_25 === "oui") {
                    // Person profile - use base64 encoded email
                    ficheCandidat = `${baseUrl}/profile?id=${btoa(project.user.user.email)}`;
                } else {
                    // Company profile
                    ficheCandidat = project.user.company?._id 
                        ? `${baseUrl}/company?id=${project.user.company._id}`
                        : `${baseUrl}/profile?id=${btoa(project.user.user.email)}`; // Fallback to profile
                }
                
                // Build the fiche projet URL
                const ficheProjet = `${baseUrl}/admin/events/fdficheprojet?email=${project.user.user.email}&pid=${project.user.participation._id}&projid=${project.projet._id}&edit-mode=true`;
                
                // Get project image URL - getProjectImage already returns full URL with process.env.REACT_APP_MEDIA_BASE_URL
                const projectImage = getProjectImage(project.projet);
                
                return {
                    project_name: project.projet.name,
                    project_name_en: project.projet.name_en || '',
                    company_or_designer_name: getEventDesignerDisplayName(project.projet, project.user),
                    fiche_candidat: ficheCandidat,
                    fiche_projet: ficheProjet,
                    project_image: projectImage || null, // This is already a full URL or null
                    project_category: getCategoryLabel(project.projet.typologie),
                    fabrication_francaise: hasFabricationFrancaise(project),
                    communiquer_fabricants: project.projet.communiquer_fabricants || ''
                };
            });
            
            const response = await api.exportFD100ProjectsBallotage(event._id, projectsForPDF);
            
            // Create a blob from the response
            const blob = new Blob([response.data], { type: 'application/pdf' });
            
            // Create a download link
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `FD100_Projets_Ballotage_${new Date().toISOString().split('T')[0]}.pdf`);
            
            // Trigger download
            document.body.appendChild(link);
            link.click();
            
            // Cleanup
            link.parentNode.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Error exporting PDF:', error);
            alert('Erreur lors de l\'export PDF');
        } finally {
            setGeneratingPDF(false);
        }
    };


    const quentinCase = (string) => {
        return string.toLowerCase().split(' ').map((s) => s.charAt(0).toUpperCase() + s.substring(1)).join(' ');
    };

    if (loading) {
        return <Spinner />;
    }

    return (
        <>
        <Container>
            <BackButton to={`/admin/events/fdcompilationjury?eid=${event?._id}`}>
                ← Retour à la compilation
            </BackButton>
            <H2>{event?.title_fr} - {ballotageMode ? "Projets en ballotage" : "Tous les projets en compétition"}</H2>
            
            {ballotageMode && (
                <div style={{
                    padding: '15px 20px',
                    marginBottom: '20px',
                    backgroundColor: '#fff3cd',
                    border: '1px solid #ffeeba',
                    borderRadius: '8px',
                    color: '#856404',
                    fontSize: '14px',
                    lineHeight: '1.5'
                }}>
                    <strong>Critères de sélection des projets en ballotage :</strong><br/>
                    • Total de 1 point de départage exactement
                </div>
            )}
            
            <HeaderSection>
                <StatsInfo>
                    {ballotageMode 
                        ? `Projets en ballotage: ${filteredProjects.length} projets` 
                        : `Total: ${allProjects.length} projets`}
                </StatsInfo>
                <div style={{display: 'flex', flexDirection: 'column', gap: '15px'}}>
                    <div style={{display: 'flex', alignItems: 'center', gap: '15px'}}>
                        <label style={{margin: '0', fontWeight: '600', display: 'flex', alignItems: 'center', gap: '15px'}}>Trier par :&nbsp;
                            <SortSelect value={sortBy} onChange={(e) => setSortBy(e.target.value)}>
                                <option value="votes">Cumul des votes</option>
                                <option value="mentions">Cumul des mentions</option>
                                <option value="commentaires">Nombre de commentaires</option>
                                <option value="name">Nom du projet</option>
                            </SortSelect>
                        </label>
                        <BallotageButton onClick={toggleBallotageMode}>
                            {ballotageMode ? '📋 Tous les projets' : '🗳️ Projets en ballotage'}
                        </BallotageButton>
                        <ExportButton
                            onClick={() => exportToExcel(false)}
                            disabled={exportingExcel}
                            title="Exporter tous les projets en compétition avec infos fabricants"
                        >
                            {exportingExcel ? <Spinner /> : '📊 Excel - Tous + fabricants'}
                        </ExportButton>
                        <ExportButton
                            onClick={() => exportToExcel(true)}
                            disabled={exportingExcel}
                            style={{ background: 'linear-gradient(135deg, #ffa726, #ff9800)' }}
                            title="Exporter uniquement les projets lauréats avec infos fabricants"
                        >
                            {exportingExcel ? <Spinner /> : '🏆 Excel - Lauréats + fabricants'}
                        </ExportButton>
                        <ExportButton
                            onClick={() => exportToExcel(true, true)}
                            disabled={exportingExcel}
                            style={{ background: 'linear-gradient(135deg, #9c27b0, #7b1fa2)' }}
                            title="Exporter uniquement les projets lauréats avec infos contact"
                        >
                            {exportingExcel ? <Spinner /> : '🏆 Excel - Lauréats'}
                        </ExportButton>
                    </div>
                    <ExportButton 
                        onClick={exportToPDF} 
                        disabled={generatingPDF}
                        style={{
                            background: generatingPDF 
                                ? 'linear-gradient(135deg, #999, #666)' 
                                : 'linear-gradient(135deg, #ff6b35, #f7931e)',
                            cursor: generatingPDF ? 'not-allowed' : 'pointer',
                            opacity: generatingPDF ? 0.7 : 1
                        }}
                    >
                        {generatingPDF ? '⏳ Génération en cours...' : '📄 Exporter les projets en ballotage en PDF'}
                    </ExportButton>
                </div>
            </HeaderSection>
            
            <ProjectGrid>
                {sortedProjects.map((project, index) => (
                    <ProjectCardWrapper key={index}>
                        {sortBy === 'votes' && !ballotageMode && (
                            <RankingBadge rank={index + 1}>#{index + 1}</RankingBadge>
                        )}
                        {ballotageMode && (
                            <SelectButton 
                                selected={selectedBallotageProjects.some(p => p.projet._id === project.projet._id)}
                                onClick={() => toggleProjectSelection(project)}
                            >
                                {selectedBallotageProjects.some(p => p.projet._id === project.projet._id) ? 'Retirer' : 'Sélectionner'}
                            </SelectButton>
                        )}
                        <ProjectCard>
                        <ProjectImage style={{ 
                            backgroundImage: getProjectImage(project.projet) ? `url(${getProjectImage(project.projet)})` : 'none' 
                        }} />
                        <CategoryBadge>{getProjectTypologieLabel(project)}</CategoryBadge>
                        {project.projet.statusFinal && (
                            <StatusBadge status={project.projet.statusFinal}>
                                {project.projet.statusFinal}
                            </StatusBadge>
                        )}
                        <ProjectName>
                            <span>{i18n.language !== 'fr' && project.projet.name_en ? project.projet.name_en : project.projet.name}</span>
                            {hasFabricationFrancaise(project) && <FabFrIndicator />}
                        </ProjectName>
                        <DesignerName>{getEventDesignerDisplayName(project.projet, project.user)}</DesignerName>
                        <RatingsInfo>
                            <RatingItem>
                                <div className="label">Votes</div>
                                <div className="value">{cumulNoteOfProj(project)}</div>
                            </RatingItem>
                            <RatingItem>
                                <div className="label">Coups de cœur</div>
                                <div className="value">{cumulMentionsForProj(project)}</div>
                            </RatingItem>
                            <RatingItem 
                                clickable={commentairesForProj(project) > 0}
                                onClick={() => commentairesForProj(project) > 0 && openComments(project)}
                            >
                                <div className="label">Commentaires</div>
                                <div className="value">{commentairesForProj(project)}</div>
                            </RatingItem>
                            {cumulDepartagePoints(project) > 0 && (
                                <RatingItem>
                                    <div className="label">Départage</div>
                                    <div className="value" style={{color: '#ff9800'}}>{cumulDepartagePoints(project)}</div>
                                </RatingItem>
                            )}
                        </RatingsInfo>
                        <ButtonContainer>
                            <ViewButton
                                to={`/admin/events/fdficheprojet?email=${project.user.user.email}&pid=${project.user.participation._id}&projid=${project.projet._id}&edit-mode=true`}
                                target="_blank"
                            >
                                Voir la fiche projet
                            </ViewButton>
                            <ViewButton
                                style={{background: 'linear-gradient(135deg, #6c757d, #495057)'}}
                                to={getEventDesignerProfileLink(project.projet, project.user)}
                                target="_blank"
                            >
                                Fiche agence
                            </ViewButton>
                            <ViewButton
                                style={{background: 'linear-gradient(135deg, #6c757d, #495057)'}}
                                to={`/profile?id=${btoa(project.user.user?.email || project.user.email)}`}
                                target="_blank"
                            >
                                Fiche candidat
                            </ViewButton>
                        </ButtonContainer>
                        </ProjectCard>
                    </ProjectCardWrapper>
                ))}
            </ProjectGrid>
            
            {showComments && selectedProject && (
                <Popup close={() => setShowComments(false)} style={{maxWidth: "900px", maxHeight: "80vh"}}>
                    <ModalHeader>
                        <h2>{quentinCase(i18n.language !== 'fr' && selectedProject.projet.name_en ? selectedProject.projet.name_en : selectedProject.projet.name)}</h2>
                        <div className="designer-name">
                            {getEventDesignerDisplayName(selectedProject.projet, selectedProject.user)}
                        </div>
                        <div className="stats">
                            <div className="stat">
                                <span className="value">{cumulNoteOfProj(selectedProject)}</span>
                                <span className="label">Total votes</span>
                            </div>
                            <div className="stat">
                                <span className="value">{cumulMentionsForProj(selectedProject)}</span>
                                <span className="label">Coups de cœur</span>
                            </div>
                            <div className="stat">
                                <span className="value">{commentairesForProj(selectedProject)}</span>
                                <span className="label">Commentaires</span>
                            </div>
                        </div>
                    </ModalHeader>
                    
                    <CommentsContainer>
                        {getProjectRatings(selectedProject).map((rating, i) => (
                            <CommentCard key={i}>
                                <JuryInfo>
                                    <div className="jury-details">
                                        <div className="name">
                                            {rating.rating?.jury?.first_name} {rating.rating?.jury?.last_name}
                                        </div>
                                        <div className="email">{rating.rating?.jury?.email}</div>
                                    </div>
                                    <div className="rating-info">
                                        <span className="score">{rating.rating?.stars || 0} / 3</span>
                                        {rating.rating?.Coup_de_coeur === "checked" && (
                                            <div className="heart">❤️ Coup de cœur</div>
                                        )}
                                    </div>
                                </JuryInfo>
                                
                                <CommentText className={!rating.rating?.commentaire ? 'no-comment' : ''}>
                                    {rating.rating?.commentaire || "Aucun commentaire laissé par ce jury"}
                                </CommentText>
                            </CommentCard>
                        ))}
                        
                        {getProjectRatings(selectedProject).length === 0 && (
                            <CommentCard>
                                <CommentText className="no-comment">
                                    Aucune évaluation disponible pour ce projet
                                </CommentText>
                            </CommentCard>
                        )}
                    </CommentsContainer>
                    
                    <ModalFooter>
                        <BlueButton onClick={() => setShowComments(false)}>Fermer</BlueButton>
                    </ModalFooter>
                </Popup>
            )}
        </Container>

            {ballotageMode && showSelectionPanel && selectedBallotageProjects.length > 0 && (
                <SelectionPanel>
                    <SelectionHeader>
                            {(() => {
                                // Number of top projects (winners)
                                const winnerCount = allProjects.filter(p => {
                                    const departage = cumulDepartagePoints(p);
                                    const votes = cumulNoteOfProj(p);
                                    const coups = cumulMentionsForProj(p);
                                    // Winner if >1 departage point
                                    if (departage > 1) return true;
                                    // Winner if 0 departage point and (votes >= 14 or (votes === 13 && coups >= 1))
                                    if (departage === 0 && (votes >= 14 || (votes === 13 && coups >= 1))) return true;
                                    return false;
                                }).length;
                                // Number of selected ballotage projects
                                const selectedCount = winnerCount + selectedBallotageProjects.length;
                                return <h3>Projets sélectionnés ({selectedCount}/100)</h3>;
                            })()}
                        <p>Glissez-déposez pour réorganiser l'ordre</p>
                    </SelectionHeader>
                    
                    <DragDropContext onDragEnd={onDragEnd}>
                        <Droppable droppableId="selected-projects">
                            {(provided) => (
                                <SelectionList
                                    {...provided.droppableProps}
                                    ref={provided.innerRef}
                                >
                                    {selectedBallotageProjects.map((project, index) => (
                                        <Draggable
                                            key={project.projet._id}
                                            draggableId={project.projet._id}
                                            index={index}
                                        >
                                            {(provided, snapshot) => (
                                                <SelectedProject
                                                    ref={provided.innerRef}
                                                    {...provided.draggableProps}
                                                    {...provided.dragHandleProps}
                                                    isDragging={snapshot.isDragging}
                                                >
                                                    <div className="rank">#{index + 1}</div>
                                                    <div className="info">
                                                        <div className="name">{i18n.language !== 'fr' && project.projet.name_en ? project.projet.name_en : project.projet.name}</div>
                                                        <div className="designer">
                                                            {getEventDesignerDisplayName(project.projet, project.user)}
                                                        </div>
                                                    </div>
                                                    <div 
                                                        className="remove"
                                                        onClick={() => removeFromSelection(project.projet._id)}
                                                    >
                                                        ✕
                                                    </div>
                                                </SelectedProject>
                                            )}
                                        </Draggable>
                                    ))}
                                    {provided.placeholder}
                                </SelectionList>
                            )}
                        </Droppable>
                    </DragDropContext>
                    
                    <SelectionFooter>
                        <ValidateButton 
                            onClick={validateSelection}
                            disabled={(() => {
                                const winnerCount = allProjects.filter(p => {
                                    const departage = cumulDepartagePoints(p);
                                    const votes = cumulNoteOfProj(p);
                                    const coups = cumulMentionsForProj(p);
                                    if (departage > 1) return true;
                                    if (departage === 0 && (votes >= 14 || (votes === 13 && coups >= 1))) return true;
                                    return false;
                                }).length;
                                return winnerCount + selectedBallotageProjects.length !== 100;
                            })()}
                        >
                            {(() => {
                                // Compute winner count with full rules
                                const winnerCount = allProjects.filter(p => {
                                    const departage = cumulDepartagePoints(p);
                                    const votes = cumulNoteOfProj(p);
                                    const coups = cumulMentionsForProj(p);
                                    if (departage > 1) return true;
                                    if (departage === 0 && (votes >= 14 || (votes === 13 && coups >= 1))) return true;
                                    return false;
                                }).length;
                                const needed = 100 - winnerCount - selectedBallotageProjects.length;
                                return needed <= 0
                                    ? "Valider la sélection finale"
                                    : `Sélectionner ${needed} projet(s) de plus`;
                            })()}
                        </ValidateButton>
                    </SelectionFooter>
                </SelectionPanel>
            )}
        </>
    );
};

export default FD100ProjectsInCompetition;